// directives/v-instance.ts
import type { Directive, DirectiveBinding } from 'vue'

const vInstance: Directive = {
    mounted(el: any, binding: DirectiveBinding) {
        const internal = (binding.instance as any).$
        el.__vueInstance = internal
    },
    updated(el: any, binding: DirectiveBinding) {
        el.__vueInstance = (binding.instance as any).$
    },
    unmounted(el: any) {
        delete el.__vueInstance
    },
}

export default vInstance
